import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgLocation = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 14,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0a7 7 0 0 1 7 7c0 3-3 9-7 13-4-4-7-10-7-13a7 7 0 0 1 7-7Zm0 1a6 6 0 0 0-6 6c0 2.566 2.476 7.522 5.648 11.157L7 18.55l.086-.093c3.212-3.561 5.776-8.549 5.909-11.244L13 7a6 6 0 0 0-6-6Zm0 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgLocation;